import { apiClient } from './api-client';
import type { ApiResponse } from './types';

/** Nationality as stored in the legacy `nodenationality` table. */
export interface NationalityRef {
  id: number;
  label: string;
}

/** A town for a postal code (legacy `geolocalisation` row). */
export interface CityRef {
  geoId: number;
  zip: string;
  city: string;
  region: string;
  country: string;
}

export const referenceApi = {
  listNationalities: async (): Promise<NationalityRef[]> => {
    const response = await apiClient.get<ApiResponse<{ nationalities: NationalityRef[] }>>(
      '/v1/public/references/nationalities',
    );
    return response.data.data.nationalities || [];
  },

  findCitiesByZip: async (zip: string): Promise<CityRef[]> => {
    const response = await apiClient.get<ApiResponse<{ cities: CityRef[] }>>(
      '/v1/public/references/cities',
      { params: { zip } },
    );
    return response.data.data.cities || [];
  },
};
